import FieldBase from './FieldBase'

export default class extends FieldBase {
  constructor({ hideLinkLabel, ...args }) {
    super(args)
    this.attrs.error = ''
    this.children = [
      {
        ...this.getComponentWithVModel('link-input'),
        props: {
          hideLinkLabel,
          errors: this.getErrorsForPath(this.modelPath)
        }
      }
    ]
  }
}
